import * as Yup from "yup";
import moment from "moment";

// Fecha de hoy según el reloj local del navegador, normalizada a UTC sin hora
// (evita que moment.utc() sin argumentos devuelva el día siguiente cuando el
// offset local ya cruzó la medianoche UTC, ej. después de las 19:00 en Perú)
const getTodayUtc = () => moment.utc(moment().format("YYYY-MM-DD"));

// Función para validar que el día sea de lunes a viernes
export const isWeekday = (dateMoment) => {
  const dayOfWeek = dateMoment.day(); // 0 = Domingo, 6 = Sábado
  return dayOfWeek >= 1 && dayOfWeek <= 5; // Lunes a Viernes
};

// Función para obtener el siguiente día hábil (lunes a viernes)
export const getNextWeekday = (dateMoment) => {
  let result = dateMoment.clone();
  while (!isWeekday(result)) {
    result.add(1, "day");
  }
  return result;
};

// Función para ajustar la fecha dentro del rango del ciclo académico
export const clampDateToCycle = (dateMoment, cycleStartMoment, cycleEndMoment) => {
  let result = dateMoment ? dateMoment.clone() : getTodayUtc();

  if (cycleStartMoment && result.isBefore(cycleStartMoment, "day")) {
    result = cycleStartMoment.clone();
  }

  if (cycleEndMoment && result.isAfter(cycleEndMoment, "day")) {
    result = cycleEndMoment.clone();
  }

  // Asegurar que sea un día hábil (lunes a viernes)
  if (!isWeekday(result)) {
    result = getNextWeekday(result);
    // Verificar nuevamente que esté dentro del ciclo después de ajustar
    if (cycleEndMoment && result.isAfter(cycleEndMoment, "day")) {
      // Si el siguiente día hábil está fuera del ciclo, buscar el día hábil anterior
      result = dateMoment.clone();
      while (!isWeekday(result) && result.isAfter(cycleStartMoment)) {
        result.subtract(1, "day");
      }
    }
  }

  return result;
};

// Opciones de asistencia
export const attendanceOptions = [
  { key: "presente", text: "Presente", value: "presente" },
  { key: "tardanza", text: "Tardanza", value: "tardanza" },
  { key: "ausente", text: "Ausente", value: "ausente" },
  { key: "justificado", text: "Falta Justificada", value: "justificado" },
];

// Valores iniciales del formulario
export function initialValues(academicCycle) {
  const cycleStartMoment = academicCycle?.startDate
    ? moment.utc(academicCycle.startDate)
    : null;
  const cycleEndMoment = academicCycle?.endDate
    ? moment.utc(academicCycle.endDate)
    : null;

  return {
    attendanceDate: clampDateToCycle(getTodayUtc(), cycleStartMoment, cycleEndMoment).format("YYYY-MM-DD"),
    status: "",
    arrivalTime: "07:30:00",
    notes: "",
  };
}

// Esquema de validación
export function validationSchema() {
  return Yup.object({
    attendanceDate: Yup.string()
      .required("Por favor selecciona una fecha de asistencia")
      .test(
        "is-weekday",
        "Solo se puede registrar asistencia de lunes a viernes",
        (value) => {
          if (!value) return true;
          const dateMoment = moment.utc(value, "YYYY-MM-DD", true);
          return dateMoment.isValid() && isWeekday(dateMoment);
        }
      ),
    status: Yup.string().required(
      "Por favor selecciona un estado de asistencia"
    ),
    arrivalTime: Yup.string().when("status", {
      is: (status) => status !== "ausente" && status !== "justificado",
      then: (schema) => schema.required("Por favor ingresa la hora de llegada"),
      otherwise: (schema) => schema,
    }),
    notes: Yup.string(),
  });
}
